import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import EmployeeForm from '../components/EmployeeForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            <EmployeeForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            <Link className='btn btn-primary btn-sm' target='_blank' to={`/employee/details/${props.data.id}`}>View</Link>
        </>
    )
  }


function EmployeeDashboardPage() {

  
  const {employeeList,getEmployeeList,getMasterLabel} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        {field:"employeeCode",headerName: "Employee Code",width:150},
        {field:"employeeName",headerName: "Employee Name",width:250},
        {headerName: "Designation", width:150,
          valueGetter:params=>{
            return getMasterLabel('employee-designation',params.data.employeeDesignation)
          }
        },
        {headerName: "Type", width:150,
          valueGetter:params=>{
            return getMasterLabel('employee-type',params.data.employeeType)
          }
        },
        {field:"phone",headerName: "Phone"},
        {field:"email",headerName: "Email"},
        {field:"state",headerName: "City"},
        {headerName:"Action", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getEmployeeList,
                remove:remove
            },
        },      
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Employee</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><EmployeeForm callBack={getEmployeeList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={employeeList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getEmployeeList}
              />
            </div>
          </div>
        </div>
    </ErpLayout>
    
  )
}

export default EmployeeDashboardPage